var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "**DASHBOARD**",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard-unblockCard",
    transform: "translate(-681.000000, -116.000000)",
    fill: "#72CA70",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF058",
    transform: "translate(681.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.203125,30.7734375 C65.203125,29.8255208 64.8984375,29.046875 64.2890625,28.4375 L59.6679688,23.8671875 C59.0247396,23.2239583 58.2630208,22.9023437 57.3828125,22.9023437 C56.5026042,22.9023437 55.7408854,23.2239583 55.0976563,23.8671875 L34.3789062,44.5351562 L22.9023437,33.0585938 C22.2591146,32.4153646 21.4973958,32.09375 20.6171875,32.09375 C19.7369792,32.09375 18.9752604,32.4153646 18.3320312,33.0585938 L13.7109375,37.6289062 C13.1015625,38.2382812 12.796875,39.0169271 12.796875,39.9648437 C12.796875,40.8789062 13.1015625,41.640625 13.7109375,42.25 L32.09375,60.6328125 C32.7369792,61.2760417 33.4986979,61.5976562 34.3789062,61.5976562 C35.2929687,61.5976562 36.0716146,61.2760417 36.7148437,60.6328125 L64.2890625,33.0585938 C64.8984375,32.4492187 65.203125,31.6875 65.203125,30.7734375 Z M72.7695313,19.4492187 C76.2565104,25.4075521 78,31.9244792 78,39 C78,46.0755208 76.2565104,52.6009115 72.7695313,58.5761719 C69.2825521,64.5514323 64.5514323,69.2825521 58.5761719,72.7695313 C52.6009115,76.2565104 46.0755208,78 39,78 C31.9244792,78 25.3990885,76.2565104 19.4238281,72.7695313 C13.4485677,69.2825521 8.71744792,64.5514323 5.23046875,58.5761719 C1.74348958,52.6009115 0,46.0755208 0,39 C0,31.9244792 1.74348958,25.3990885 5.23046875,19.4238281 C8.71744792,13.4485677 13.4485677,8.71744792 19.4238281,5.23046875 C25.3990885,1.74348958 31.9244792,0 39,0 C46.0755208,0 52.6009115,1.74348958 58.5761719,5.23046875 C64.5514323,8.71744792 69.2825521,13.4570312 72.7695313,19.4492187 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActivate);
export default __webpack_public_path__ + "static/media/ic_activate.2894c9d1a5e94ce3cffc22b4758b6aee.svg";
export { ForwardRef as ReactComponent };